import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  value?: boolean;
  onChange: (value: boolean) => void;
  offLabel: string;
  onLabel: string;
  className?: string;
}

export const LabelledSwitch: FC<Props> = ({ value, onChange, offLabel, onLabel, className }) => {
  const onClass = 'bg-secondary-600 text-white';
  const offClass = 'bg-white hover:bg-primary-std';

  return (
    <div
      className={twMerge(
        className,
        'border border-primary-std rounded-lg overflow-hidden flex items-stretch text-primary-std text-medium'
      )}
    >
      <button className={twMerge('border-r px-5 py-1.5', value ? offClass : onClass)} onClick={() => onChange(false)}>
        {offLabel}
      </button>
      <button className={twMerge('px-5 py-1.5', value ? onClass : offClass)} onClick={() => onChange(true)}>
        {onLabel}
      </button>
    </div>
  );
};
